module.exports = __webpack_public_path__ + "img/condutor.d7ce973d.png";